<template>
    <div class="h-full bg-box rounded shadow-md">
        <div class="flex flex-col justify-between h-full">
            <div class="mb-1 px-4 flex items-center justify-between rounded-t site-title-bar">
                <div class="p-3 text-xl text-white font-bold w-full" :class="showOptions ? 'text-left' : 'text-center'">{{ title }}</div>
                <div class="flex items-center">
                    <InfoIcon identifier="dashboard-portfoliobenchmark" />
                    <div v-if="showOptions" title="Options">
                        <v-popover offset="10">
                            <button>
                                <inline-svg name="settings" class="text-white"></inline-svg>
                            </button>

                            <template slot="popover">
                                <div class="p-3">
                                    <h1 class="text-xl text-gray-900 mr-32 mb-6">Benchmark Options</h1>
                                    <div class="mb-4 text-lg text-gray-900">
                                        <div class="flex justify-between mb-5">
                                            <span class="text-sm">Use Advanced Calculation</span>
                                            <toggle-button v-model="advancedCalculation" @change="benchmark" color="#38C172" sync></toggle-button>
                                        </div>
                                        <div class="flex justify-between mb-5">
                                            <span class="text-sm">Show Last Year's Value</span>
                                            <toggle-button v-model="showLastYear" color="#38C172" sync></toggle-button>
                                        </div>
                                        <div class="flex justify-between">
                                            <span class="text-sm">Show Average Range</span>
                                            <toggle-button v-model="showAverageRange" color="#38C172" sync></toggle-button>
                                        </div>
                                    </div>
                                    <div class="flex justify-center m-2">
                                        <button class="btn btn-blue" v-close-popover>Close</button>
                                    </div>
                                </div>
                            </template>
                        </v-popover>
                    </div>
                  
                </div>
            </div>
            

            <div class="relative h-full flex flex-col items-center justify-between">
                <fusioncharts
                    type="angulargauge"
                    width="98%"
                    :height="height"
                    :dataSource="dataSource">
                </fusioncharts>
                <div class="text-xl text-white text-center font-bold my-6">
                    <span>Currently</span>
                    <span class="p-2 font-bold mx-1 rounded" :class="benchmarkColor">
                        <span v-text="benchmarkPercentage" class="text-white" :class="{ 'text-yellow-600': benchmark === 0 }"></span>
                    </span>
                    <span v-text="overUnder"></span>
                    <span>Market</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },

            height: {
                type: String,
                default: "300"
            },

            showOptions: {
                type: Boolean,
                default: false
            },

            benchmark: {
                type: Number,
                required: true,
            },
        },

        data () {
            return {
                advancedCalculation: true,
                showLastYear: false,
                showAverageRange: false,
                showTooltip: false,
            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        bgColor: "#316DA0",
                        baseFont: '"-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"',
                        baseFontSize: 15,
                        caption: "",
                        lowerLimit: "-100",
                        upperLimit: "100",
                        showValue: "0",
                        numberSuffix: "%",
                        theme: "fusion",
                        showToolTip: "0",
                        majorTMColor: "#ffffff",
                        valueFontSize: 16,
                        labelFontColor: "#ffffff",
                        pivotRadius: "10",
                        pivotFillMix: "{CCCCCC},{EEEEEE}",
                        pivotFillRatio: "50,50",
                        gaugeFillMix: "{light-10},{light-30},{light-20},{dark-5},{color},{light-30},{light-20},{dark-10}",
                        gaugeFillRatio: "",
                    },
                    colorRange: {
                        color: [
                            {
                                minValue: -100,
                                maxValue: -5,
                                code: "#62B58F"
                            },
                            {
                                minValue: -5,
                                maxValue: 5,
                                code: "#FFC533"
                            },
                            {
                                minValue: 5,
                                maxValue: 100,
                                code: "#F2726F"
                            }
                        ]
                    },
                    dials: {
                        dial: [
                            {
                                value: this.benchmark,
                                borderAlpha: "100",
                                rearExtension: "15",
                                borderColor: "#B8C2CC",
                                borderThickness: "1",
                                bgColor: "#F1F1F1",
                                topWidth: "1",
                                baseWidth: "6"
                            }
                        ]
                    },
                    trendpoints: {
                        point: [
                            {
                                startValue: "60",
                                displayValue: "Last Year",
                                color: "#0075c2",
                                thickness: "2",
                                radius: "180",
                                innerRadius: "82",
                                alpha: this.showLastYear ? "100" : "0",
                                trendValueDistance: "3"
                            },
                            {
                                startValue: "-5",
                                color: "#1F9D55",
                                dashed: "1",
                                alpha: this.showAverageRange ? "100" : "0",
                                trendValueDistance: "25"
                            },
                            {
                                startValue: "45",
                                color: "#1F9D55",
                                dashed: "1",
                                alpha: this.showAverageRange ? "100" : "0",
                                trendValueDistance: "25"
                            },
                            {
                                startValue: "-5",
                                endValue: "45",
                                color: "#A2F5BF",
                                radius: "155",
                                innerRadius: "40",
                                alpha: this.showAverageRange ? "100" : "0",
                            }
                        ]
                    }
                }
            },

            benchmarkPercentage() {
                return Math.abs(this.benchmark) + "%";
            },

            benchmarkColor() {
                return this.benchmark > 0 ? "bg-red-600" : (this.benchmark < 0 ? "bg-green-400" : "bg-yellow-300");
            },

            overUnder() {
                return this.benchmark >= 0 ? "Over" : "Under";
            },
        }
    }
</script>